export const ERROR_MESSAGES = {};

export const MESSAGE_TOOLTIP = {
    PRACTICEL_LEVEL: <div className="max-w-[500px] space-y-[5px] mobile2:max-w-[300px] mobile3:!max-w-[200px]">
        <p>
            <b className="underline underline-offset-2">Advanced</b> - have the expertise to perform up to high complexity engagements, also have people who are considered subject matter experts.
        </p>
        <p>
            <b className="underline underline-offset-2">Established</b> - have the ability to perform basic to moderate complexity engagements, serve a minimum of three clients within this practice area.
        </p>
        <p>
            <b className="underline underline-offset-2">Novice</b> - have people with 2-3 years of experience, suitable to assist with engagements and potentially lead a field team, but not manage engagements.
        </p>
        <p>
            <b className="underline underline-offset-2">Start-up</b> - have people with basic training and 0-1 years of experience in the practice area, suitable to assist with engagements but need supervision and on-the-job training.
        </p>
    </div>,

    PRACTICEL_LEVEL_COMPARE: <div className="max-w-[500px] space-y-[5px] mobile2:max-w-[300px] mobile3:!max-w-[200px]">
        <div >
            <div className="flex flex-row items-center space-x-[5px] mb-[3px]">
                <ul className="flex flex-row space-x-[3px] m-0 p-0">
                    <li className="w-[10px] h-[6px] bg-[#2C76AA]"></li> 
                    <li className="w-[10px] h-[6px] bg-[#2C76AA]"></li> 
                    <li className="w-[10px] h-[6px] bg-[#2C76AA]"></li> 
                    <li className="w-[10px] h-[6px] bg-[#2C76AA]"></li> 
                </ul>
                <b className="underline underline-offset-2 ">Advanced:</b>
            </div>
            <p className="ml-[10px]">Have the expertise to perform up to high complexity engagements, also have people who are considered subject matter experts.</p>
        </div>
        <div  >
            <div className="flex flex-row items-center space-x-[5px] mb-[3px]">
                <ul className="flex flex-row space-x-[3px] m-0 p-0">
                    <li className="w-[10px] h-[6px] bg-[#2C76AA]"></li> 
                    <li className="w-[10px] h-[6px] bg-[#2C76AA]"></li> 
                    <li className="w-[10px] h-[6px] bg-[#2C76AA]"></li> 
                    <li className="w-[10px] h-[6px] bg-white"></li> 
                </ul>
                <b className="underline underline-offset-2">Established:</b>
            </div>
            <p className="ml-[10px]">
                Have the ability to perform basic to moderate complexity engagements, serve a minimum of three clients within this practice area.
            </p>
        </div>
        <div  >
            <div className="flex flex-row items-center space-x-[5px] mb-[3px]">
                <ul className="flex flex-row space-x-[3px] m-0 p-0">
                    <li className="w-[10px] h-[6px] bg-[#2C76AA]"></li> 
                    <li className="w-[10px] h-[6px] bg-[#2C76AA]"></li> 
                    <li className="w-[10px] h-[6px] bg-white"></li> 
                    <li className="w-[10px] h-[6px] bg-white"></li> 
                </ul>
                <b className="underline underline-offset-2 ">Novice:</b>
            </div>
            <p className="ml-[10px]">Have people with 2-3 years of experience, suitable to assist with engagements and potentially lead a field team, but not manage engagements.</p>
        </div>
        <div  >
            <div className="flex flex-row items-center space-x-[5px] mb-[3px]">
                <ul className="flex flex-row space-x-[3px] m-0 p-0">
                    <li className="w-[10px] h-[6px] bg-[#2C76AA]"></li> 
                    <li className="w-[10px] h-[6px] bg-white"></li> 
                    <li className="w-[10px] h-[6px] bg-white"></li> 
                    <li className="w-[10px] h-[6px] bg-white"></li> 
                </ul>
                <b className="underline underline-offset-2 ">Start-up:</b>
            </div>
            <p className="ml-[10px]">Have people with basic training and 0-1 years of experience in the practice area, suitable to assist with engagements but need supervision and on-the-job training.</p>
        </div>
    </div>
}

export const MESSAGE_NOTIFI = {
    INQUIRY_SECONDMENT: "The inquiry is sent separately to organization contacts. Contacts from different organizations or secondments cannot see each other.",
    INQUIRY_PRODUCTS: "The inquiry is sent separately to organization contacts. Contacts from different organizations or products cannot see each other.",
    INQUIRY_SERVICES: "The inquiry is sent separately to organization contacts. Contacts from different organizations or services cannot see each other.",
    INQUIRY_FIRMS: "The inquiry is sent separately to firm contacts. Contacts from different firms cannot see each other.",
    NOTE_EMAILL_CC: 'The sender has been added to the CC: for easy use of the "Reply All" in email.'
}